/*
 * This is a similar component to StockResultsHeader. It is a rewrite of it
 * for the rdsStockView with a little less functionality since not all functinality
 * that is used for the regular stock view is needed in the rdwStockPage and the
 * intention is for this component to replace the StockResultsheader and add the
 * necessary functionality needed for the stock page (mainly the salesToggle and mobile
 * filters button) to this component at that time.
 */
import { useHistory, useLocation } from 'react-router-dom'
import ActionIconButton from 'components/atoms/action-icon-button'
import DisplayModeToggle from 'components/atoms/display-mode-toggle'
import { DISPLAY_MODE_DEFAULT } from 'config/consts'
import { CarFileViewTypeEnum, DisplayModeEnum } from 'config/enums'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import React, { useContext, useState } from 'react'
import styled, { ThemeContext } from 'styled-components/macro'
import { useMediaLayout } from 'use-media'
import { media } from 'utilities/styled'
import { getObjectFromQueryString, handleChangeQuery } from 'utilities/utils'
import NewDropdownSelect from 'components/molecules/new-dropdown-select'

const Container = styled.div`
  align-items: center;
  display: grid;
  grid-gap: 20px;
  grid-template-areas:
    'filters sort'
    'count  controls';
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 1fr 1fr;
  ${media.desktop`
    grid-template-areas: "count controls";
    grid-template-rows: auto;
  `}
  ${media.desktop`
    display: flex;
  `};
`
const StyledControls = styled.div`
  grid-area: controls;
  display: flex;
  justify-content: ${({ $isDesktop }) =>
    $isDesktop ? 'flex-end' : 'flex-start'};
  margin-left: ${({ $isDesktop }) => ($isDesktop ? 'auto' : '0')};
  gap: ${({ theme }) => theme.sizeByFactor(2)};
  ${media.desktop`
      gap: ${({ theme }) => theme.sizeByFactor(2.5)};
  `};
  width: ${({ $isDesktop }) => ($isDesktop ? 'auto' : '100%')};
`
const StyledNewDropDownSelect = styled(NewDropdownSelect)`
  width: ${({ theme, $isDesktop }) =>
    $isDesktop ? theme.sizeByFactor(20.5) : '100%'};
  label {
    color: ${({ theme }) => theme.colors.brandCharlie};
  }
  > div {
    background-color: ${({ theme }) => theme.colors.brandGolf} !important;
  }
`
function StockHeader({
  hideMobileFiltersButton,
  onSortOptionChange,
  salesView,
  stockViewType,
  setStockViewType,
  selectedSortOption,
  sortOptions,
  toggleMobileFilters,
  toggleSalesView,
  displayMode,
  setDisplayMode,
  pageHeaderOptionsSlot,
  showViewTypeDropdown,
  ...restProps
}) {
  const { t } = useTranslation()
  const theme = useContext(ThemeContext)
  const isDesktop = useMediaLayout({ minWidth: theme.metrics.desktop })
  const carFileViewTypeOptions = [
    {
      label: t('carFileEnrichment.carFileViewTypes.standard'),
      selected: false,
      value: CarFileViewTypeEnum.STANDARD,
    },
    {
      label: t('carFileEnrichment.carFileViewTypes.sales'),
      selected: false,
      value: CarFileViewTypeEnum.SALES,
    },
    {
      label: t('carFileEnrichment.carFileViewTypes.marktplaats'),
      selected: false,
      value: CarFileViewTypeEnum.MARKTPLAATS,
    },
    {
      label: t('carFileEnrichment.carFileViewTypes.ads'),
      selected: false,
      value: CarFileViewTypeEnum.ADS,
    },
  ]
  const history = useHistory()
  const location = useLocation()
  const allParams = getObjectFromQueryString(location.search)
  const selectedViewType = allParams.view || stockViewType
  const [viewType, setViewType] = useState(
    selectedViewType ?? carFileViewTypeOptions[0].value,
  )
  const handleChange = (value) => {
    const queryValue =
      value === CarFileViewTypeEnum.ADVERTISEMENT
        ? CarFileViewTypeEnum.ADS
        : value
    handleChangeQuery(location, history, 'view', queryValue)
    setViewType(value)
    if (setStockViewType) {
      setStockViewType(queryValue)
    }
  }
  return (
    <Container sortOptions={sortOptions} {...restProps}>
      <StyledControls $isDesktop={isDesktop}>
        {!isDesktop && showViewTypeDropdown && (
          <StyledNewDropDownSelect
            selectionRequired
            filled
            value={viewType}
            label={t('weergave')}
            onChange={handleChange}
            items={carFileViewTypeOptions}
          />
        )}
        {pageHeaderOptionsSlot && !isDesktop && pageHeaderOptionsSlot}
        {!hideMobileFiltersButton && !isDesktop && (
          <ActionIconButton
            onClick={toggleMobileFilters}
            selected={0}
            data-test-e2e="show-filters-mobile"
            icon="filter"
            iconOnly={!isDesktop}
          />
        )}
        {displayMode && setDisplayMode && (
          <DisplayModeToggle
            displayMode={displayMode}
            setDisplayMode={setDisplayMode}
          />
        )}
        {isDesktop && showViewTypeDropdown && (
          <StyledNewDropDownSelect
            $isDesktop
            selectionRequired
            filled
            value={viewType}
            label={t('weergave')}
            onChange={handleChange}
            items={carFileViewTypeOptions}
          />
        )}
      </StyledControls>
    </Container>
  )
}
StockHeader.propTypes = {
  hideMobileFiltersButton: PropTypes.bool,
  onSortOptionChange: PropTypes.func,
  salesView: PropTypes.bool,
  selectedSortOption: PropTypes.string,
  sortOptions: PropTypes.arrayOf(PropTypes.object),
  stockViewType: PropTypes.string,
  setStockViewType: PropTypes.func,
  toggleSalesView: PropTypes.func,
  toggleMobileFilters: PropTypes.func,
  displayMode: PropTypes.oneOf(Object.values(DisplayModeEnum)),
  setDisplayMode: PropTypes.func,
  pageHeaderOptionsSlot: PropTypes.node,
  showViewTypeDropdown: PropTypes.bool,
}
StockHeader.defaultProps = {
  onSortOptionChange: null,
  hideMobileFiltersButton: false,
  salesView: false,
  selectedSortOption: null,
  sortOptions: null,
  toggleMobileFilters: null,
  stockViewType: null,
  setStockViewType: null,
  toggleSalesView: null,
  displayMode: DISPLAY_MODE_DEFAULT,
  showViewTypeDropdown: false,
}
export default StockHeader
